module.exports = __webpack_public_path__ + "img/tsg-logo.2fb2ebb1.svg";